// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__Uhkt7","summary":"CartItem_summary__g8iFu","price":"CartItem_price__igS14","amount":"CartItem_amount__Xz-pK","actions":"CartItem_actions__bxL8T"};